import React from 'react';
export function BonusStack() {
  const bonuses = [{
    id: 1,
    title: 'The Ultimate Soccer Practice Builder',
    pages: '40–50 pages',
    value: '$27',
    desc: 'A step-by-step system for building professional training sessions in minutes — not hours.',
    img: 'https://cdn.magicpatterns.com/uploads/dyCav4CEcPaz8dLjdAr3cG/Bono_2.webp'
  }, {
    id: 2,
    title: 'The Youth Soccer Parent Management Playbook',
    pages: '30–50 pages',
    value: '$27',
    desc: 'Scripts, templates, and strategies for managing parent expectations and keeping everyone aligned.',
    img: 'https://cdn.magicpatterns.com/uploads/fP9N8UPyMpcq2RP6rgu3Xp/Bono_3.webp'
  }, {
    id: 3,
    title: 'The 100 Fun Soccer Games Handbook',
    pages: '40–50 pages',
    value: '$19',
    desc: '100 engaging games that keep players excited, motivated, and coming back every week.',
    img: 'https://cdn.magicpatterns.com/uploads/3SA2UDv8hqCxj16oXsM3D5/Bono_4.webp'
  }, {
    id: 4,
    title: "The Soccer Coach's Season Planner",
    pages: '40–50 pages',
    value: '$19',
    desc: 'A complete annual planning and organization system so every month of the season has purpose.',
    img: 'https://cdn.magicpatterns.com/uploads/tepxQHixVJC9xXrDKY8xvu/Bono_1.webp'
  }, {
    id: 5,
    title: 'The Confident Coach Blueprint',
    pages: '30–50 pages',
    value: '$27',
    desc: 'Leadership, communication, and confidence systems for coaches who want to grow beyond the pitch.',
    img: 'https://cdn.magicpatterns.com/uploads/vyZAh16o6K1wfgdtZqBk4c/Bono_5.webp'
  }];
  return <section className="bg-forest py-24 px-4 border-t border-white/5" data-id="element-34">
      <div className="max-w-5xl mx-auto" data-id="element-35">
        <h2 className="font-display text-4xl md:text-5xl text-white text-center mb-16 uppercase leading-tight" data-id="element-36">
          And When You Join Today, You Also Get These{' '}
          <span className="text-amber" data-id="element-37">5 Strategic Bonuses — Free</span>
        </h2>

        <div className="space-y-6 mb-12" data-id="element-38">
          {bonuses.map(bonus => <div key={bonus.id} className="bg-ink rounded-xl border border-white/10 overflow-hidden flex flex-col md:flex-row items-center gap-6 p-6" data-id="element-39">
              <div className="w-full md:w-48 shrink-0 flex justify-center" data-id="element-40">
                <img src={bonus.img} alt={bonus.title} className="w-32 md:w-full h-auto rounded shadow-lg border border-white/5" data-id="element-41" />
              </div>
              <div className="flex-1 text-center md:text-left" data-id="element-42">
                <div className="inline-block bg-amber/20 text-amber font-bold text-xs px-3 py-1 rounded uppercase tracking-wider mb-3" data-id="element-43">
                  Bonus #{bonus.id} • Value: {bonus.value}
                </div>
                <h3 className="font-display text-2xl text-white mb-2" data-id="element-44">
                  {bonus.title}
                </h3>
                <p className="text-sm text-gray-400 mb-3 uppercase tracking-wide" data-id="element-45">
                  {bonus.pages}
                </p>
                <p className="text-gray-300 leading-relaxed" data-id="element-46">{bonus.desc}</p>
              </div>
            </div>)}
        </div>

        <div className="bg-ink border border-amber/30 rounded-xl p-6 text-center" data-id="element-47">
          <p className="font-display text-2xl md:text-3xl text-amber uppercase tracking-wide" data-id="element-48">
            Total Bonus Value: $119 — Yours FREE with Soccer Ready™ Today
          </p>
        </div>
      </div>
    </section>;
}